import { useMemo } from 'react';

import type { IObjectTabDataProps } from '../../../helpersAndTypes';
import { getObjectsTree } from '../../../helpersAndTypes';

export const useObjectTableData = (props: IObjectTabDataProps) => {
    const { workOrderObjects, objectTabFilters, constructionTypeId } = props;

    const workOrderChildObjects = useMemo(
        () => workOrderObjects?.filter((obj: any) => obj.constructionType?.id === constructionTypeId),
        [constructionTypeId, workOrderObjects],
    );

    const objTree = useMemo(
        () =>
            objectTabFilters?.object?.id
                ? getObjectsTree(workOrderChildObjects ?? [], objectTabFilters?.object?.id)
                : [],
        [objectTabFilters?.object?.id, workOrderChildObjects],
    );

    return useMemo(
        () => [{ ...objectTabFilters?.object, name: objectTabFilters?.object?.label, level: 0 }, ...objTree],
        [objTree, objectTabFilters?.object],
    );
};
